if (!customElements.get('yc-blessing5')) {
  customElements.define('yc-blessing5', class YCBlessing5 extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.videos = this.querySelectorAll('video');
      this.iframes = this.querySelectorAll('iframe');
      this.imageWrapper = this.querySelector('.yc-blessing5__image-wrapper');
      
      if (this.videos.length > 0 || this.iframes.length > 0) {
        this.initPlayer();
      }
    }

    getActiveVideo() {
      const desktop = this.querySelector('.yc-blessing5__video--desktop');
      const mobile = this.querySelector('.yc-blessing5__video--mobile');
      
      if (desktop && window.getComputedStyle(desktop).display !== 'none') {
        return desktop;
      }
      if (mobile && window.getComputedStyle(mobile).display !== 'none') {
        return mobile;
      }
      return desktop || mobile || this.videos[0];
    }

    initPlayer() {
      if (!this.imageWrapper) return;

      this.activeVideo = this.getActiveVideo();

      this.imageWrapper.addEventListener('click', () => {
        if (!this.activeVideo) return;
        
        if (this.activeVideo.paused) {
          this.videos.forEach(v => {
            if (v !== this.activeVideo) v.pause();
          });
          this.activeVideo.play();
          this.imageWrapper.classList.add('is-playing');
        } else {
          this.activeVideo.pause();
          this.imageWrapper.classList.remove('is-playing');
        }
      });

      if (this.activeVideo) {
        this.activeVideo.addEventListener('ended', () => {
          this.imageWrapper.classList.remove('is-playing');
        });
      }

      window.addEventListener('resize', () => {
        const newActiveVideo = this.getActiveVideo();
        if (newActiveVideo !== this.activeVideo) {
          if (this.activeVideo && !this.activeVideo.paused) {
            this.activeVideo.pause();
            this.imageWrapper.classList.remove('is-playing');
          }
          if (this.activeVideo) {
            this.activeVideo.removeEventListener('ended', this.handleEnded);
          }
          
          this.activeVideo = newActiveVideo;
          
          if (this.activeVideo) {
            this.activeVideo.addEventListener('ended', this.handleEnded);
          }
        }
      });
    }

    handleEnded = () => {
      if (this.imageWrapper) {
        this.imageWrapper.classList.remove('is-playing');
      }
    }

    disconnectedCallback() {
      // Clean up if necessary
    }
  });
}
